import { Auth0UserWithCustomClaims } from './RealizeUser'
import { NetworkBridgingLogInAppState } from './authState'

export function isFirstLogIn(appState: NetworkBridgingLogInAppState, user?: Auth0UserWithCustomClaims) {
  const { realize_login_request_id } = appState ?? {}
  const existingLoginId = user?.['https://upgradehealth.com/jwt/claims']?.loginRequestId
  return existingLoginId === realize_login_request_id
}
